import aba from "../assets/img/payment/aba.webp";
import bred from "../assets/img/payment/bred-bank.jpg";
import khqr from "../assets/img/payment/khqr.jpg";
import cash from "../assets/img/payment/cash.jpg";

const payment = [
  {
    img: aba,
    title: "ABA",
  },
  {
    img: bred,
    title: "Bred Bank",
  },
  {
    img: khqr,
    title: "KHQR",
  },
  {
    img: cash,
    title: "Cash on hand",
  },
];
export { payment };
